<style scoped>


.blogs a {
    text-decoration: none;
    background-color: transparent;
    -webkit-text-decoration-skip: objects;
}
.blogs img {
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -moz-user-drag: none;
    max-width: 100%;
    vertical-align: middle;
    border-style: none;
    height: 600px;
    width: 95%;
}
.blogs p {
    font-weight: 400;
    line-height: 24px;
    margin: 0 0 1rem;
    letter-spacing: 0;
}

@media (min-width: 62em){
    .uGKdM{
        padding-top: 0px;
        flex: 0 0 30%;
        max-width: 30%;
    }
}
.uGKdM {
    padding-top: 2rem;
}
.cbUqlq {
    line-height: 1.5;
    font-size: 1.25rem;
    text-decoration: none;
}
.dqTBkN {
    display: flex;
    flex-direction: column;
    padding: 1.5rem;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 4px 16px 0px;
    border-radius: 16px;
}
.gCoFLX {
    padding-bottom: 1rem;
    line-height: 1.25;
    display: flex;
}
.cDJQaG.small {
    margin: 0px 10px 0px 0px;
}
.cDJQaG.small img {
    height: 40px;
    width: 50px;
    border-radius: 4px;
    object-fit: cover;
}
.hhVGAC {
    flex: 3 1 0%;
}
.cQUkRA {
    display: block;
    color: rgb(118, 118, 118);
    font-size: 11px;
}
.gcfudH {
    font-size: 14px;
}
@media (min-width: 62em){
    .cOrWKb {
        gap: 1.5rem;
        max-width: 70%;
    }
}
.cOrWKb {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
</style>
<template>
    <section class="featured-categories-wrap blog-category">
        <div class="container d-flex">
            <div class="cOrWKb">
                <div class="tab-content blogs" v-if="details.image != null">
                    <figure class="wp-block-image size-large">
                        <img :alt="details.title" :src="details.image" height="200" width="1000">
                    </figure>
                </div>
                <div class="details_descriptions" v-html="details.description"></div>
            </div>
            <!-- recent blog posts -->
            <div class="uGKdM">
                <h3 class="cbUqlq">Recent Posts</h3>
                <div class="dqTBkN">
                    <div class="gCoFLX"  v-for="recentblog in recentBlogs" :key="recentblog.id" >
                        <div class="cDJQaG small">
                            <a :aria-label="recentblog.title" :href="recentblog.url">
                                <img v-if="recentblog.image != null" width="85" height="85" :src="recentblog.image" :alt="recentblog.title" loading="lazy">
                                <img v-else width="85" height="85" src="/themes/storefront/public/images/image-placeholder.png" :alt="recentblog.title" loading="lazy">
                            </a>
                        </div>
                        <div class="hhVGAC">
                            <span class="cQUkRA">{{ recentblog.date }}</span>
                            <strong class="gcfudH">
                                <a :href="recentblog.url">{{ recentblog.title }}</a>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        data() {
            return {
                details: [],
                recentBlogs: []
            };
        },
        mounted() {
            var id = window.location.href.split('/').pop();
            this.loading = true;
            $.ajax({
                method: "GET",
                url: '/it/getpostdetails/'+id,
                context: this
            }).then(async details => {
                this.details = details.response;
            });

            $.ajax({
                method: "GET",
                url: '/it/getrecentblogposts?id='+id,
                context: this
            }).then(async recentBlogs => {
                this.recentBlogs = recentBlogs.response;
            });
        },
    };
</script>
